"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceProvider = void 0;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _source = require("../../selectors/source");
function mapStateToProps(state) {
  return {
    source: (0, _source.sourceSelector)(state)
  };
}
const SourceProvider = exports.SourceProvider = (0, _reactRedux.connect)(mapStateToProps);